import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { stElemnt } from "../../../../St/Reviews/cStyle";
import { colors } from "@material-ui/core";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles((theme) => ({
    table: {
      fontFamily: "Amiri-Regular",
      direction: "rtl",
      minWidth: 700,
    minHeight:"26rem"
     
    },
    tableRightBorder: {
      ...stElemnt.AF.headerAcc,
      fontWeight: "bold",
      padding:"5px",
      border: "solid 0px",
      border: "solid 0.1px",
      color:"#fff",
      fontWeight:"bold",
      fontSize:"0.9rem",
    },

    rowHeader: {
      fontFamily: "Amiri-Regular",
      fontWeight: "bold",
      paddingTop: "2px",
      paddingBottom:"2px",
      border: "solid 0px",
      border: "solid 0.1px",
      color:"#fff",

    },
    headerrows:{
      ...stElemnt.AF.headerAcc,
      backgroundColor: "#81007f",
      fontWeight: "bold",
      paddingTop: "2px",
      paddingBottom:"2px",
      border: "solid 0px",
      border: "solid 0.1px",
      color:"#fff",

    },
    rowsStyle:{
      //...stElemnt.AF.cellCust,
      padding: "5px 0px",
      textAlign: "-webkit-center",
      margin: "0px",
      whiteSpace: "nowrap",
      width: "0px",
      border: "solid 0.1px",
      fontWeight:"bold",
      fontSize:"0.9rem",
      fontFamily: "Amiri-Regular",
    }
  
  }));

export default function AccountsSystemTable(props) {
  const { data, isPrinter,title } = props;
  const { t } = useTranslation(["forms"]);

  const styla={ 
    ...stElemnt.AF.headerAcc,
    paddingTop: "2px",
    paddingBottom:"2px",
    border: "solid 0px",
    border: "solid 0.1px",
    fontWeight:"bold",
    fontSize:"1rem",
};
  const classes = useStyles();
  return (
    <TableContainer component={Paper} >
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow
            style={styla}
            
          >
            <TableCell align="center" colSpan={2}></TableCell>
            <TableCell
              align="center"
              colSpan={2}
              className={classes.tableRightBorder}
            >
              {t("initial-balance")}
            </TableCell>
            <TableCell
              className={classes.tableRightBorder}
              align="center"
              colSpan={2}
            >
              {t("prev-balance")}
            </TableCell>
            <TableCell
              className={classes.tableRightBorder}
              align="center"
              colSpan={2}
            >
              {" "}
              {t("acc-move")}
            </TableCell>
            <TableCell
              className={classes.tableRightBorder}
              align="center"
              colSpan={2}
            >
              {t("acc-balance")}
            </TableCell>
          </TableRow>
          <TableRow
            style={{
              backgroundColor: colors.blue[300],
              fontSize: 18,
              fontFamily: "Amiri-Regular",
              color: "#000",
            }}
          >
            <TableCell className={classes.tableRightBorder} align="center">
              {t("account-code")}
            </TableCell>
            <TableCell className={classes.tableRightBorder} align="center">
              {t("account")}
            </TableCell>
            <TableCell
              className={classes.tableRightBorder}
              style={{ fontWeight: 800, fontSize: 16 }}
              align="center"
            >
              {" "}
              {t("dept")}
            </TableCell>
            <TableCell className={classes.tableRightBorder} align="center">
              {" "}
              {t("credit")}
            </TableCell>
            <TableCell
              className={classes.tableRightBorder}
              style={{ fontWeight: 800, fontSize: 16 }}
              align="center"
            >
              {" "}
              {t("dept")}{" "}
            </TableCell>
            <TableCell className={classes.tableRightBorder} align="center">
              {" "}
              {t("credit")}
            </TableCell>
            <TableCell className={classes.tableRightBorder} align="center">
              {" "}
              {t("dept")}{" "}
            </TableCell>
            <TableCell className={classes.tableRightBorder} align="center">
              {" "}
              {t("credit")}{" "}
            </TableCell>
            <TableCell className={classes.tableRightBorder} align="center">
              {" "}
              {t("dept")}{" "}
            </TableCell>
            <TableCell className={classes.tableRightBorder} align="center">
              {" "}
              {t("credit")}{" "}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row) => (
            <TableRow key={row.id}
            style={{
                 ...stElemnt.AF.cellCust,
                padding: "0px 1px",}}
                
            >
              <TableCell align="center" className={classes.rowsStyle}>
                {row.ac}
              </TableCell>
              <TableCell align="center" className={classes.rowsStyle}>
                {row.AName}
              </TableCell>
              <TableCell align="center" className={classes.rowsStyle}>
                {row.val_open_dept?.toFixed(2) ?? "-"}
              </TableCell>
              <TableCell align="center" className={classes.rowsStyle}>
                {row.val_open_credit?.toFixed(2) ?? "-"}
              </TableCell>
              <TableCell align="center" className={classes.rowsStyle}>
                {row.OB_DR_AMT_L?.toFixed(2) ?? "-"}
              </TableCell>
              <TableCell align="center" className={classes.rowsStyle}>
                {row.OB_CR_AMT_L?.toFixed(2) ?? "-"}
              </TableCell>
              <TableCell align="center" className={classes.rowsStyle}>
                {row.DR_AMT_L?.toFixed(2) ?? "-"}
              </TableCell>
              <TableCell align="center" className={classes.rowsStyle}>
                {row.CR_AMT_L?.toFixed(2) ?? "-"}
              </TableCell>
              <TableCell align="center" className={classes.rowsStyle}>
                {row.End_DR_AMT_L?.toFixed(2) ?? "-"}
              </TableCell>
              <TableCell align="center" className={classes.rowsStyle}>
                {row.End_CR_AMT_L?.toFixed(2) ?? "-"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
